import React from 'react';

import './style.scss';

const PromotionalBetMark = ({ data = {} }) => {
  const labels = {
    free_bet_amount: 'freebet',
    is_risk_free_bet: 'risk free',
    boost_percentage: 'profit boost',
  };

  return (
    <div>
      {Object.keys(labels).map(key => data[key] ? <span key={key} className="promotion-info">{labels[key]}</span> : '')}
    </div>
  );
};
 export default PromotionalBetMark;
